import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { handleHashScroll } from '../utils/scrollUtils';

const ProductsPage = () => {
  useEffect(() => {
    handleHashScroll();
  }, []);

  return (
    <div className="page">
      {/* Hero Section */}
      <section className="hero" style={{minHeight: '60vh', paddingTop: 'calc(80px + var(--spacing-xl))'}}>
        <div className="bg-shape bg-shape-1 floating"></div>
        <div className="container hero-content">
          <span className="section-label">Our Products</span>
          <h1>Powerful SaaS Solutions</h1>
          <p>Industry-leading software products designed to streamline your operations and accelerate business growth.</p>
        </div>
      </section>

      {/* Nok Spa Management Suite */}
      <section id="nok-spa" className="section">
        <div className="container">
          <div className="section-header">
            <span className="section-label">Featured Product</span>
            <h2 className="section-title">Nok Spa Management Suite</h2>
            <p className="section-description">The complete business management solution for spas, salons, and wellness centers. Everything you need to run your business efficiently in one powerful platform.</p>
          </div>

          {/* Product Overview */}
          <div className="grid grid-2" style={{marginBottom: 'var(--spacing-xl)', gap: 'var(--spacing-xl)'}}>
            <div className="card reveal-left hover-lift" style={{padding: 'var(--spacing-xl)'}}>
              <h3 style={{color: 'var(--color-blue-light)', marginBottom: 'var(--spacing-md)'}}>Key Features</h3>
              <ul style={{listStyle: 'none', padding: 0}}>
                {[
                  {title: 'Appointment Scheduling', desc: 'Smart calendar with automated reminders and confirmations'},
                  {title: 'Client Management', desc: 'Comprehensive CRM with visit history and preferences'},
                  {title: 'Inventory Control', desc: 'Track products, supplies, and auto-reorder alerts'},
                  {title: 'Staff Management', desc: 'Scheduling, commission tracking, and performance metrics'},
                  {title: 'Point of Sale', desc: 'Fast checkout with integrated payment processing'},
                  {title: 'Analytics Dashboard', desc: 'Real-time insights and detailed business reports'}
                ].map((feature, i, arr) => (
                  <li key={i} style={{padding: '0.75rem 0', borderBottom: i < arr.length - 1 ? '1px solid var(--color-black-lighter)' : 'none', color: 'var(--color-gray)'}}>
                    <strong style={{color: 'var(--color-white)'}}>{feature.title}</strong><br/>
                    <span style={{fontSize: '0.9375rem'}}>{feature.desc}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="reveal-right" style={{display: 'flex', flexDirection: 'column', gap: 'var(--spacing-md)'}}>
              <div className="card hover-lift" style={{padding: 'var(--spacing-md)', background: 'linear-gradient(135deg, var(--color-blue-dark), var(--color-blue-light))'}}>
                <h4 style={{marginBottom: 'var(--spacing-sm)'}}>Mobile App Included</h4>
                <p style={{margin: 0, fontSize: '0.9375rem'}}>Manage your business on the go with our iOS and Android apps. Check schedules, process payments, and view analytics from anywhere.</p>
              </div>

              <div className="card hover-lift" style={{padding: 'var(--spacing-md)'}}>
                <h4 style={{marginBottom: 'var(--spacing-sm)'}}>Cloud-Based Platform</h4>
                <p style={{margin: 0, fontSize: '0.9375rem', color: 'var(--color-gray-dark)'}}>Access from any device with internet. Automatic backups, 99.9% uptime, and enterprise-grade security included.</p>
              </div>

              <div className="card hover-lift" style={{padding: 'var(--spacing-md)'}}>
                <h4 style={{marginBottom: 'var(--spacing-sm)'}}>24/7 Support</h4>
                <p style={{margin: 0, fontSize: '0.9375rem', color: 'var(--color-gray-dark)'}}>Our dedicated support team is always available to help you succeed. Email, phone, and live chat support included.</p>
              </div>
            </div>
          </div>

          {/* Pricing Tiers - Hidden, contact for pricing */}
          {/* <h3 className="text-center" style={{margin: 'var(--spacing-xl) 0 var(--spacing-lg)'}}>Choose Your Plan</h3>
          <div className="grid grid-3" style={{marginBottom: 'var(--spacing-lg)'}}>...</div> */}

          <div className="text-center reveal-fade" style={{marginTop: 'var(--spacing-lg)', padding: 'var(--spacing-xl)', backgroundColor: 'var(--color-black-lighter)', borderRadius: '12px'}}>
            <h3 style={{marginBottom: 'var(--spacing-md)'}}>Interested in Nok Spa Management Suite?</h3>
            <p style={{color: 'var(--color-gray)', marginBottom: 'var(--spacing-md)', fontSize: '1.125rem'}}>Contact us for pricing information, custom demos, and to discuss how our solution can fit your business needs.</p>
            <Link to="/contact?product=nok-spa" className="btn btn-primary" style={{padding: '1rem 2rem'}}>Contact Us for Inquiry</Link>
          </div>
        </div>
      </section>

      {/* Nok POS */}
      <section id="sevenhc-pos" className="section" style={{backgroundColor: '#0F0F0F'}}>
        <div className="container">
          <div className="section-header">
            <span className="section-label" style={{color: 'var(--color-blue-light)'}}>New Release</span>
            <h2 className="section-title">Nok POS</h2>
            <p className="section-description">Modern point-of-sale system designed for retail businesses. Fast, intuitive, and packed with features to help you sell more and manage better.</p>
          </div>

          {/* Product Overview */}
          <div className="grid grid-2" style={{marginBottom: 'var(--spacing-xl)', gap: 'var(--spacing-xl)'}}>
            <div className="reveal-left" style={{order: 2}}>
              <div className="card" style={{padding: 'var(--spacing-xl)'}}>
                <h3 style={{color: 'var(--color-blue-light)', marginBottom: 'var(--spacing-md)'}}>Core Capabilities</h3>
                <ul style={{listStyle: 'none', padding: 0}}>
                  {[
                    {title: 'Lightning-Fast Checkout', desc: 'Intuitive interface that reduces transaction time'},
                    {title: 'Inventory Management', desc: 'Real-time tracking, low stock alerts, and bulk updates'},
                    {title: 'Multi-Location Support', desc: 'Manage multiple stores from a single dashboard'},
                    {title: 'Employee Management', desc: 'Role-based permissions and sales tracking'},
                    {title: 'Payment Processing', desc: 'Accept all major payment methods securely'},
                    {title: 'Customer Loyalty', desc: 'Built-in loyalty programs and rewards management'}
                  ].map((feature, i, arr) => (
                    <li key={i} style={{padding: '0.75rem 0', borderBottom: i < arr.length - 1 ? '1px solid var(--color-black-lighter)' : 'none', color: 'var(--color-gray)'}}>
                      <strong style={{color: 'var(--color-white)'}}>{feature.title}</strong><br/>
                      <span style={{fontSize: '0.9375rem'}}>{feature.desc}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="reveal-right" style={{order: 1, display: 'flex', flexDirection: 'column', gap: 'var(--spacing-md)'}}>
              <div className="card" style={{padding: 'var(--spacing-lg)', background: 'linear-gradient(135deg, var(--color-black-light), var(--color-black-lighter))'}}>
                <h4 style={{marginBottom: 'var(--spacing-md)'}}>Perfect For</h4>
                <div style={{display: 'flex', flexWrap: 'wrap', gap: 'var(--spacing-sm)'}}>
                  {['Retail Stores', 'Boutiques', 'Pharmacies', 'Grocery Stores', 'Gift Shops', 'Convenience Stores'].map(type => (
                    <span key={type} style={{backgroundColor: 'var(--color-blue-dark)', padding: '0.5rem 1rem', borderRadius: '20px', fontSize: '0.875rem', color: 'white'}}>{type}</span>
                  ))}
                </div>
              </div>

              <div className="card hover-lift" style={{padding: 'var(--spacing-md)'}}>
                <h4 style={{marginBottom: 'var(--spacing-sm)'}}>Offline Mode</h4>
                <p style={{margin: 0, fontSize: '0.9375rem', color: 'var(--color-gray-dark)'}}>Continue selling even without internet. Transactions sync automatically when connection is restored.</p>
              </div>

              <div className="card hover-lift" style={{padding: 'var(--spacing-md)'}}>
                <h4 style={{marginBottom: 'var(--spacing-sm)'}}>Hardware Compatible</h4>
                <p style={{margin: 0, fontSize: '0.9375rem', color: 'var(--color-gray-dark)'}}>Works with existing hardware: receipt printers, barcode scanners, cash drawers, and more.</p>
              </div>
            </div>
          </div>

          {/* Pricing Tiers - Hidden, contact for pricing */}
          {/* <h3 className="text-center" style={{margin: 'var(--spacing-xl) 0 var(--spacing-lg)'}}>Simple, Transparent Pricing</h3>
          <div className="grid grid-3" style={{marginBottom: 'var(--spacing-lg)'}}>...</div> */}

          <div className="text-center reveal-fade" style={{marginTop: 'var(--spacing-lg)', padding: 'var(--spacing-xl)', backgroundColor: 'var(--color-black-lighter)', borderRadius: '12px'}}>
            <h3 style={{marginBottom: 'var(--spacing-md)'}}>Interested in Nok POS?</h3>
            <p style={{color: 'var(--color-gray)', marginBottom: 'var(--spacing-md)', fontSize: '1.125rem'}}>Contact us for pricing information, product demonstrations, and to learn how Nok POS can transform your retail operations.</p>
            <Link to="/contact?product=nok-pos" className="btn btn-primary" style={{padding: '1rem 2rem'}}>Contact Us for Inquiry</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductsPage;
